import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { Alert } from '@statsbomb/kitbag-components';

export function ErrorText({ errorMessage }) {
  const intl = useIntl();

  const messages = {
    'Auth Required': {
      message: (
        <FormattedMessage
          defaultMessage="Login to the statsbomb video application to proceed"
          description="Login to video app"
          id="90952"
        />
      ),
      type: 'warning',
    },
    'Network Error': {
      message: (
        <FormattedMessage
          defaultMessage="There's been a network error"
          description="Network Error"
          id="6c75b"
        />
      ),
      type: 'error',
    },
    'Request failed with status code 400': {
      message: (
        <FormattedMessage
          defaultMessage="Please check inputs and try again. If a URL was provided ensure it's accessible"
          id="dc5e0"
        />
      ),
      title: intl.formatMessage({
        defaultMessage: 'Request failed due to an invalid input.',
        id: '392bc',
      }),

      type: 'error',
    },
    'Request failed with status code 404': {
      message: (
        <FormattedMessage
          defaultMessage="No video found for this match/period"
          id="c0cd6"
        />
      ),
      type: 'warning',
    },
    unknown: {
      message: (
        <FormattedMessage
          defaultMessage="There's been an unexpected error"
          description="Unexpected Error"
          id="f51ae"
        />
      ),
      type: 'error',
    },
  };
  const error = messages[errorMessage] || messages.unknown;

  return (
    errorMessage && (
      <Alert type={error.type} title={error.title}>
        {error.message}
      </Alert>
    )
  );
}

ErrorText.propTypes = { errorMessage: PropTypes.string.isRequired };

export default { ErrorText };
